/**
 * FBS — comportements de la landing page.
 *
 * Reprend la logique du prototype de design, en s'appuyant sur les classes CSS
 * plutôt que sur des styles inline : le JS ne fait que basculer des états, la
 * mise en forme reste dans les SCSS.
 */

( function () {
	'use strict';

	var prefersReducedMotion = window.matchMedia
		? window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches
		: false;

	/**
	 * Révèle les éléments [data-reveal] à l'entrée dans le viewport.
	 *
	 * Si l'utilisateur a demandé moins d'animations, tout est révélé d'emblée :
	 * les laisser à opacity 0 rendrait le contenu inaccessible.
	 */
	function initReveal() {
		var items = document.querySelectorAll( '[data-reveal]' );

		if ( ! items.length ) {
			return;
		}

		if ( prefersReducedMotion || ! ( 'IntersectionObserver' in window ) ) {
			Array.prototype.forEach.call( items, function ( el ) {
				el.classList.add( 'is-revealed' );
			} );
			return;
		}

		var observer = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( ! entry.isIntersecting ) {
						return;
					}

					var delay = parseInt( entry.target.getAttribute( 'data-reveal-delay' ) || '0', 10 );

					window.setTimeout( function () {
						entry.target.classList.add( 'is-revealed' );
					}, delay );

					observer.unobserve( entry.target );
				} );
			},
			{ threshold: 0.1 }
		);

		Array.prototype.forEach.call( items, function ( el ) {
			observer.observe( el );
		} );
	}

	/**
	 * Bascule l'état de la navbar au-delà de 40px de scroll.
	 *
	 * Le travail est reporté dans un requestAnimationFrame : l'écouteur de
	 * scroll ne fait qu'armer un drapeau, il ne touche jamais au DOM lui-même.
	 */
	function initScroll() {
		var navbar = document.querySelector( '[data-fbs-navbar]' );
		var ticking = false;

		if ( ! navbar ) {
			return;
		}

		function update() {
			var y = window.scrollY || window.pageYOffset;

			navbar.classList.toggle( 'is-scrolled', y > 40 );

			ticking = false;
		}

		window.addEventListener(
			'scroll',
			function () {
				if ( ticking ) {
					return;
				}

				ticking = true;
				window.requestAnimationFrame( update );
			},
			{ passive: true }
		);

		update();
	}

	/**
	 * Synchronise le libellé et l'icône des déclencheurs de collapse.
	 *
	 * Le collapse lui-même reste géré par Bootstrap ; on ne fait qu'écouter ses
	 * événements pour échanger « Mehr erfahren » / « Weniger erfahren » et +/−.
	 */
	function initReadMore() {
		function sync( event, isOpen ) {
			var selector = '#' + event.target.id;
			var triggers = document.querySelectorAll(
				'[data-bs-target="' + selector + '"], [href="' + selector + '"]'
			);

			Array.prototype.forEach.call( triggers, function ( trigger ) {
				var label = trigger.querySelector( '[data-rm-label]' );
				var icon = trigger.querySelector( '[data-rm-icon]' );

				if ( label ) {
					label.textContent = isOpen
						? trigger.getAttribute( 'data-less' )
						: trigger.getAttribute( 'data-more' );
				}

				if ( icon ) {
					icon.textContent = isOpen ? '−' : '+';
				}
			} );
		}

		document.addEventListener( 'shown.bs.collapse', function ( e ) {
			sync( e, true );
		} );
		document.addEventListener( 'hidden.bs.collapse', function ( e ) {
			sync( e, false );
		} );
	}

	/**
	 * Ouvre le bon formulaire de contact depuis un CTA de section.
	 *
	 * Un lien [data-form-target="unternehmen"] fait défiler jusqu'à #kontakt et
	 * active l'onglet correspondant.
	 */
	function initFormDeepLinks() {
		document.addEventListener( 'click', function ( event ) {
			var link = event.target.closest && event.target.closest( '[data-form-target]' );

			if ( ! link ) {
				return;
			}

			var which = link.getAttribute( 'data-form-target' );
			var tab = document.getElementById( 'tab-' + which );

			if ( tab && window.bootstrap ) {
				window.bootstrap.Tab.getOrCreateInstance( tab ).show();
			}
		} );
	}

	/**
	 * Referme le menu mobile quand on suit un de ses liens.
	 *
	 * L'attribut data-bs-dismiss de Bootstrap ferait le travail, mais son
	 * gestionnaire appelle preventDefault() sur les <a> : le panneau se fermerait
	 * sans que le lien n'aboutisse. On ferme donc à la main, sans toucher à
	 * l'événement, pour que la navigation suive son cours.
	 */
	function initMobileNav() {
		var panel = document.getElementById( 'fbsMobileNav' );

		if ( ! panel ) {
			return;
		}

		panel.addEventListener( 'click', function ( event ) {
			var link = event.target.closest && event.target.closest( 'a[href]' );

			if ( ! link || ! window.bootstrap ) {
				return;
			}

			var instance = window.bootstrap.Offcanvas.getInstance( panel );

			if ( instance ) {
				instance.hide();
			}
		} );
	}

	function init() {
		initReveal();
		initScroll();
		initReadMore();
		initFormDeepLinks();
		initMobileNav();
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}() );
